import { withAuthenticationRequired } from '@auth0/auth0-react';
import React, { type ComponentType } from 'react';

interface AuthGuardProps {
  component: ComponentType; // Ensures the component is a valid React component type
}

export default function AuthGuard({ component }: AuthGuardProps) {
  const Component = withAuthenticationRequired(component, {
    onRedirecting: () => <div>{/* <PageLoader /> */}</div>,
  });

  return <Component />;
}
